const features = [
  {
    title: '实时追踪',
    desc: '7×24小时全天候监控全网娱乐动态，重大事件15分钟内推送快讯，不错过任何一个瓜。',
    icon: 'ri-radar-line',
  },
  {
    title: '深度解析',
    desc: '不止于表面吃瓜，专业编辑团队为您梳理事件时间线，还原完整真相，提供多角度分析。',
    icon: 'ri-search-eye-line',
  },
  {
    title: '匿名保护',
    desc: '所有爆料人均享受端到端加密保护，投稿渠道全程匿名，确保爆料人信息安全无虞。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '证据整理',
    desc: '每条爆料均标注信息来源与可信度，提供原始截图、录音、视频等一手证据材料归档。',
    icon: 'ri-file-text-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            为什么千万吃瓜群众选择我们？四大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-6 text-center group hover:bg-primary-50/50 transition-colors">
              <span className="w-14 h-14 flex items-center justify-center mx-auto bg-primary-100 text-primary-600 rounded-xl mb-5">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}